// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tab-pane[data-v-2f160d58] {\r\n  height: auto !important;\r\n  /* overflow-y: auto; */\n}\r\n", ""]);
// Exports
module.exports = exports;
